/* eslint-disable import/no-named-as-default-member */
import dayjs from 'dayjs'

export const FULL_DATE_FORMAT = 'MMMM DD, YYYY'

export const formatDate = (
  date: string | Date,
  format: string = FULL_DATE_FORMAT,
) => dayjs(date).tz('Asia/Manila').format(format)

export const toDate = (date: string) => dayjs.tz(date, 'Asia/Manila')

export const formatCurrency = (fee: number) =>
  fee.toLocaleString('en-US', { style: 'currency', currency: 'PHP' })
